
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import Slick from "vue-slick";
import { HeaderData, NeighboorhoodCoords, NeighborhoodPlanQmiCounts, NeighborhoodPlatMap, NeighborhoodSoldDetails, Sibling } from "../types";
import NeighborhoodItem from "./AppHeaderNeighborhoodListItem.vue";
import AppHeaderCircle from './AppHeaderCircle.vue'
@Component({
  components: {
    NeighborhoodItem,
    Slick,
    AppHeaderCircle,
  },
})
export default class NeighborhoodList extends Vue {
  $refs!: any;
  sliderOptions: any = {
    slidesToShow: 1.4,
    slidesToScroll: 1,
    infinite: false,
    adaptiveHeight: true,
    // variableWidth: true,
  };
  @Prop() coordinates: NeighborhoodPlatMap[];
  @Prop() private siblings!: Sibling[];
  @Prop() private headerData!: HeaderData;
  @Prop() private soldPercentage!: NeighborhoodSoldDetails[]
  @Prop() private selectedNeighborhoodIds!: string[];
  @Prop() private neighborhoodsPlanQmiCount!: NeighborhoodPlanQmiCounts[];
  @Prop() private qmiFilter!: boolean;
  @Prop() private isAnyFilterApplied!: boolean;
  @Prop() totalMobileFilterApplied!: number;
  @Emit("sethoverNeighborZoomLevel")sethoverNeighborZoomLevel(zoomLevel: number, isDisableHoverNeighbor: boolean, centerMap: NeighboorhoodCoords){}
  @Emit("loadNeighborhood") loadNeighborhood(
    areaName: string,
    communityName: string,
    neighborhoodName: string
  ) { }
  @Emit("hideSibling")hideSibling(){}
  @Emit("clearSelectedNeighborhoods") clearSelectedNeighborhoods() {}
  @Emit("selectNeighborhood") selectNeighborhood (neighborhoodId: string) {}
  @Emit('highlightNeighborhood')highlightNeighborhood(neighborhoodId: string, display: string){}
  @Watch("selectedNeighborhoodIds") showCurrentSlide(value: string[]) {
    this.previewCurrentNeighborhood();
  }
  mounted() {
    this.previewCurrentNeighborhood();
  }
  isComingSoon (sibling : Sibling) {
    return sibling.nb_unit_status?.toLowerCase().includes('coming soon');
  }
  checkAndClearNeighborhood(){
    if(this.isAnyFilterApplied || this.selectedNeighborhoodIds.length || this.totalMobileFilterApplied){
      this.clearSelectedNeighborhoods();
    }
  }

  get showClearButton(){
    return this.isAnyFilterApplied || this.selectedNeighborhoodIds.length || this.totalMobileFilterApplied;
  }
  previewCurrentNeighborhood() {
    if (this.selectedNeighborhoodIds) {
      const currentNeighborhoodIndex = this.siblings.findIndex((sibling) => sibling.id === this.selectedNeighborhoodIds[0]);
      this.$refs.slick && this.$refs.slick.goTo(currentNeighborhoodIndex, false);
    }
  }
  neighborhoodSoldPercentage(neighborhoodId: string) {
    return this.soldPercentage.find((percentage) => percentage.neighborhoodId === neighborhoodId)?.soldPercentage;
  }

  // neighborhoodPlanQmisCount(neighborhodId: string) {
  //   return this.neighborhoodsPlanQmiCount.find((neighborhood) => neighborhood.neighborhoodId === neighborhodId);
  // }

  neighborhoodLotsCount(neighborhodId: string) {
    return this.soldPercentage.find(percentage => percentage.neighborhoodId === neighborhodId)?.totalLotsCount;
  }
}
